var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"44b05e2767e3d37f68413a01c57b7d10d67d6141"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-main@flipgive"]={id:"44b05e2767e3d37f68413a01c57b7d10d67d6141"};
      